// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__fTO7U","buttons":"SendReceipts_buttons__kwVOZ","email":"SendReceipts_email__2EHcC","bookApptTitle":"SendReceipts_bookApptTitle__2Eq0y"};